module.exports = __webpack_public_path__ + "img/input-spinner.db29fe82.gif";